$('form[name="lecture-list-form"] select').on('change', function () {
    $(this).parents('form').submit();
});
